import { SessionStorage } from './cookie-storage'
import { STORAGEKEYS } from './keys'

/// Uwaga: Scisle powiazany kod jest w `OTP.Domain.WorkflowState`
export class WorkflowTypes {
  public static readonly OTP_NORMAL = 0;
  public static readonly OTP_RETENTION = 1;
  public static readonly LEN_NORMAL = 2; // Start procesu przez integratora (starting-form)
  public static readonly LEN_RETENTION = 3;
  public static readonly LEN_PAYTREE_NORMAL = 4; //Start procesu przez formularz openy
  public static readonly LEN_PAYTREE_RETENTION = 5;

  public static IsRetention(type: number): boolean {
    return this.OTP_RETENTION === type || this.LEN_RETENTION === type || this.LEN_PAYTREE_RETENTION === type;
  }

  public static isNormal(type: number): boolean {
    return this.OTP_NORMAL === type || this.LEN_NORMAL === type || this.LEN_PAYTREE_NORMAL === type;
  }

  public static isFromExternalIntegrator(): boolean {
    const sessionStorage = new SessionStorage()
    const currentWorkflowType = Number(sessionStorage.get(STORAGEKEYS.CURRENT_WORKFLOW_ID)) ?? undefined

    return !Number.isNaN(currentWorkflowType) && currentWorkflowType === this.LEN_NORMAL
  }


  public static isFromOpenaForm(): boolean {
    const sessionStorage = new SessionStorage()
    const currentWorkflowType = Number(sessionStorage.get(STORAGEKEYS.CURRENT_WORKFLOW_ID)) ?? undefined

    return !Number.isNaN(currentWorkflowType) && currentWorkflowType === this.LEN_PAYTREE_NORMAL
  }
}